import { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { t } from 'ttag';

import { socialFeed, socialSimilarFeed } from '@urls';
import { ProfileSocialPostsFeed } from '@components/profile/ProfileSocialPostsFeed';

import { useProfileSocialPostsLikedQuery } from './gql/graphql.v5.generated';

export const ProfileSocialPostsLikedContainer = () => {
  const { data: postsData, networkStatus, fetchMore } = useProfileSocialPostsLikedQuery({
    context: {
      v5: true,
      batch: true,
    },
    notifyOnNetworkStatusChange: true,
  });

  const pageInfo = postsData?.me?.postsLiked?.pageInfo;

  const handleLoadMore = useCallback(async () => {
    if (pageInfo?.hasNextPage && networkStatus === NetworkStatus.ready) {
      await fetchMore({
        variables: {
          after: pageInfo?.endCursor,
        },
      });
    }
  }, [fetchMore, networkStatus, pageInfo?.endCursor, pageInfo?.hasNextPage]);

  const posts = useMemo(() => {
    const resultPosts = postsData?.me?.postsLiked.edges
      .map(({ node }) => node.post)
      .filter((post) => post.mediasUrls.length) || [];

    return resultPosts;
  }, [postsData?.me?.postsLiked.edges]);

  const emptyTitle = t`Тут з'являться пости, яким ви поставили вподобайки на Оглядах чи в Стрічці`;

  const emptyLink = {
    title: t`До Стрічки`,
    pathname: socialFeed,
  };

  return (
    <ProfileSocialPostsFeed
      posts={posts}
      isLoading={networkStatus === NetworkStatus.loading}
      hasNextPage={!!pageInfo?.hasNextPage}
      emptyTitle={emptyTitle}
      emptyLink={emptyLink}
      getPostUrl={(post) => generatePath(socialSimilarFeed, { postId: post.id })}
      onLoadMore={handleLoadMore}
    />
  );
};
